
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attention",
      function () {
        return require("private-next-pages/attention.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attention"])
      });
    }
  